import React, { useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { motion, useInView } from 'framer-motion'
import './ProjectCategories.css'

const CATEGORIES = [
    { key: 'restobar',    label: 'Restaurants',  image: '/Images/Honey_Spice/exterior.jpeg',                count: 3 },
    { key: 'residential', label: 'Residential',  image: '/Images/Gowri_Residence/living_room_rensder_2.jpeg', count: 3 },
    { key: 'commercial',  label: 'Office Spaces', image: '/Images/Cals_Office/reception_render.jpeg',        count: 2 },
    { key: 'hospitality', label: 'Hospitality',  image: '/Images/Sriram_JB_Residency/Interior.jpg',         count: 1 },
    { key: 'food_court', label: 'Food Court',  image: '/Images/Food_Street/Entracne.jpeg',                count: 1 },
]

const containerVariants = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { staggerChildren: 0.1, delayChildren: 0.05 } },
}

const cardVariants = {
    hidden: { opacity: 0, y: 28 },
    show:   { opacity: 1, y: 0,  transition: { duration: 0.6, ease: [0.25, 0.1, 0.25, 1] } },
}

const CategoryCard = ({ category, onClick }) => (
    <motion.button
        className="cat-card"
        variants={cardVariants}
        onClick={() => onClick(category.key)}
        aria-label={`Browse ${category.label} projects`}
    >
        <img src={category.image} alt={category.label} className="cat-card__image" />
        <div className="cat-card__overlay" />
        <div className="cat-card__body">
            <span className="cat-card__eyebrow">{category.count} {category.count === 1 ? 'project' : 'projects'}</span>
            <h3 className="cat-card__title">{category.label}</h3>
            <span className="cat-card__arrow">→</span>
        </div>
    </motion.button>
)

const ProjectCategories = () => {
    const navigate = useNavigate()
    const gridRef = useRef(null)
    const isInView = useInView(gridRef, { once: true, margin: '-8% 0px' })

    const handleCategoryClick = (filterKey) => {
        navigate('/projects', { state: { initialFilter: filterKey } })
    }

    return (
        <section className="categories-section" id="our-work">
            <div className="categories-inner">
                <div className="categories-header">
                    <p className="categories-eyebrow">Our Work</p>
                    <h2 className="categories-heading">Browse by Category</h2>
                </div>
                <motion.div
                    className="categories-grid"
                    ref={gridRef}
                    variants={containerVariants}
                    initial="hidden"
                    animate={isInView ? 'show' : 'hidden'}
                >
                    {CATEGORIES.map((cat) => (
                        <CategoryCard key={cat.key} category={cat} onClick={handleCategoryClick} />
                    ))}
                </motion.div>
                <div className="categories-footer">
                    <button className="categories-view-all" onClick={() => handleCategoryClick('all')}>
                        Explore Our Work →
                    </button>
                </div>
            </div>
        </section>
    )
}

export default ProjectCategories
